export default {
  BusinessReportSaleCensus: {
    orderTime: '统计时间',
    dateType: '统计时间类型',
    channel: '渠道',
    totalSales: '总销售',
    orderCount: '正向订单数',
    orderCount2: '销售订单数',
    itemCount: '正向销售件数',
    orderAmount: '正向订单金额',
    reverseOrderCount: '逆向订单数',
    reverseOrderCount2: '退货订单数',
    reverseItemCount: '逆向退款件数',
    reverseOrderAmount: '逆向退款金额',
    reverseItem: '净销售件数',
    netSalesAmount: '净销售金额',
    itemCost: '商品总成本',
    itemProfit: '毛利',
    channelTypeMeaning: '销售渠道',
    totalSave: '总销售',
    goodsQuantity: '正向销售金额',
  }
};
